export default __webpack_public_path__ + "static/not-found-72f3c2e4ef06b1de1dc90a356dc212ae.svg";